module.exports = __webpack_public_path__ + "img/misparaim_no.a2dab5df.png";